export default __webpack_public_path__ + "static/media/citypic.12d1fc4c.jpg";